import { PartnerListPage } from '@/features/partners/components/partner-list-page';

export function PartnerProspectsRoute(): JSX.Element {
  return (
    <PartnerListPage
      type="prospect"
      titleKey="partners.prospects.title"
      subtitleKey="partners.prospects.subtitle"
      createLabelKey="partners.actions.createProspect"
      formPreset="prospect"
      defaultSort="leadScore:desc"
      allowKanban
    />
  );
}
